import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { MessageService } from 'primeng/api';
import { SavedSearchModel } from 'src/app/models/saved-search-model';
import { ConstantsService } from 'src/app/services/constants.service';
import { QueryStateService } from 'src/app/services/query-state.service';
import { SavedSearchService } from 'src/app/services/saved-search.service';

@Component({
  selector: 'app-results-actions',
  templateUrl: './results-actions.component.html',
  styleUrls: ['./results-actions.component.css']
})
export class ResultsActionsComponent implements OnInit {
  constructor(
    private constants: ConstantsService,
    private clipboardApi: ClipboardService,
    private msgService: MessageService,
    private saveSearchSvc: SavedSearchService,
    private messageSvc: MessageService,
    private querySvc: QueryStateService
  ) {
    this.currentView = this.constants.results_view_summary;
  }

  @Input() searchQuery?: string;
  @Input() total: number = 0;
  @Input() currentView: string;
  @Input() query?: string | null;
  @Input() routeLink: string = '';
  @Input() pageSize: number = 25;
  @Input() first: number = 0;

  @Output() changeView = new EventEmitter<string>();
  @Output() onPageChange = new EventEmitter<any>();
  @Output() downloadResults = new EventEmitter<any>();
  @Output() downloadResultsExcel = new EventEmitter<any>();
  @Output() onToggleFacets = new EventEmitter<any>();

  // showCopyMsg: boolean = false;
  // switchViewText: string = 'Switch View';
  
  // Saved Search Items
  // saveSearchVisible = false;
  // saveSearchName: string = '';
  // savedSearchItem?: SavedSearchModel;
  // isInvalidFilename:boolean = false;

  ngOnInit(): void {
    // this.updateViewToolTip();
  }

  paginate(event: any) {
    this.onPageChange.emit(event);
  }

  // toggleView() {
  //   if (this.currentView === this.constants.results_view_summary) {
  //     this.currentView = this.constants.results_view_table;
  //     this.updateViewToolTip();
  //   } else {
  //     this.currentView = this.constants.results_view_summary;
  //     this.updateViewToolTip();
  //   }
  //   this.changeView.emit(this.currentView);
  // }

  // updateViewToolTip() {
  //   let nextView = this.constants.results_view_summary;

  //   if (this.currentView === this.constants.results_view_summary) {
  //     nextView = this.constants.results_view_table;
  //   } else {
  //     nextView = this.constants.results_view_summary;
  //   }

  //   this.switchViewText = 'Switch to ' + this.capFirstLetter(nextView) + ' view';
  // }

  // capFirstLetter(str: string) {
  //   return str.charAt(0).toUpperCase() + str.slice(1);
  // }

  // saveResults() {
  //   //TODO: Ensure All items are retrieved...
  //   this.downloadResults.emit();
  // }

  // saveResultsExcel() {
  //   this.downloadResultsExcel.emit();
  // }

  // saveSearch() {
  //   this.saveSearchVisible = true;
  //   // let qd = encodeURIComponent(JSON.stringify(this.querySvc.getFormData()));
  //   // this.savedSearchItem = { query: qd, formData: qd, id: '', displayName: '' };
  //   this.saveSearchName = '';
  // }

  // executeSavedSearch() {
  //   this.saveSearchSvc.saveSearch(this.saveSearchName.trim(), this.querySvc.getFormData());
  //   this.saveSearchVisible = false;
  //   this.messageSvc.add({ severity: 'success', summary: 'Item Saved!', detail: 'Search has been saved!', key: 'saveSearch' });
  // }

  // searchNameLength() {
  //   return this.saveSearchName.trim().length;
  // }

  // validateFilename() {
  //   const invlaidChars = /[<>:"\/\\|?*\x00-\x1F"]/g;
  //   this.isInvalidFilename = invlaidChars.test(this.saveSearchName);
  // }

  // copyClipboard() {
  //   // console.log('query: ' + JSON.stringify(this.query));

  //   if (this.query) {
  //     this.clipboardApi.copyFromContent(this.routeLink);
  //     this.showCopyMsg = true;
  //     // console.log("copied!");
  //     this.msgService.add({ severity: 'success', summary: 'Search Copied', detail: 'Search Query Copied to Clipboard!' });
  //   }
  // }
}
